











































import { Configuration, DoctorInfoRestControllerApi } from '@/types/api-docs'
import Vue from 'vue'
import Utils from '@/utils/utils'

const infoApi = new DoctorInfoRestControllerApi(new Configuration({ basePath: `${window.location.origin}` }))

export interface DataType {
  pageName: string
  breadcrumbs: unknown[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tab: any
  tabItems: unknown[]
}

export default Vue.extend({
  name: 'ConferenceMemberHome',

  data(): DataType {
    return {
      pageName: 'HOME',
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
          disabled: true,
        },
      ],
      tab: null,
      tabItems: [],
    }
  },
  async mounted() {
    let conferenceNotifications
    await this.fetchConferenceNotificationOverviews().then((content) => {
      conferenceNotifications = content
    })
    let paidNotifications
    await this.fetchPaidDoctorPaymentOverviews().then((content) => {
      paidNotifications = content
    })
    let adminNotifications
    await this.fetchAdminInfoOverviews().then((content) => {
      adminNotifications = content
    })
    const conferenceHeaders = [
      { text: '配信日', value: 'sendDatetime', sortable: true, width: '10%' },
      { text: 'タイトル', value: 'title', sortable: false, width: '90%' },
    ]
    const paidHeaders = [
      { text: '配信日', value: 'sendDatetime', sortable: true, width: '10%' },
      { text: '支払い内容', value: 'paymentContent', sortable: false, width: '80%' },
      { text: '支払い期限', value: 'deadline', sortable: true, width: '10%' },
    ]
    const adminHeaders = [
      { text: '配信日', value: 'sendDatetime', sortable: true, width: '10%' },
      { text: 'タイトル', value: 'title', sortable: false, width: '90%' },
    ]

    this.tabItems = [
      {
        tab: Utils.switchOrganization(this.$store.getters.organization, '学会', '組織'),
        type: 'conference',
        icon: 'mdi-city',
        headers: conferenceHeaders,
        contents: conferenceNotifications,
      },
      // {
      //   tab: '支払',
      //   type: 'payment',
      //   icon: 'mdi-receipt',
      //   headers: paidHeaders,
      //   contents: paidNotifications,
      // },
      {
        tab: '運営',
        type: 'admin',
        icon: 'mdi-account-tie',
        headers: adminHeaders,
        contents: adminNotifications,
      },
    ]
  },
  methods: {
    async fetchConferenceNotificationOverviews() {
      const { data } = await infoApi.fetchConferenceInfoOverviews()
      return data.content
    },
    async fetchPaidDoctorPaymentOverviews() {
      const { data } = await infoApi.fetchPaidDoctorPaymentOverviews()
      return data.content
    },
    async fetchAdminInfoOverviews() {
      const { data } = await infoApi.fetchAdminInfoOverviews()
      return data.content
    },
    formatDate(date: string, format: string) {
      return Utils.formatStringDate(date, format)
    },
  },
})
